import React from 'react';

import { Button, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';
import { useTracking } from '@change-corgi/core/react/tracking';

export const CTASection: React.FC = () => {
	const track = useTracking();

	return (
		<div className="flex flex-col items-start justify-between gap-6 rounded-xl bg-gradient-background-dark-3 px-6 py-6 max-sm:items-stretch md:flex-row md:items-center md:px-10">
			<Text as="h2" variant="heading" size="small" className="text-typography-inverse-strong">
				<Translate value="corgi.topic_page.cta.alt_section_text" />
			</Text>

			<Button
				variant="primary"
				className="max-md:w-full"
				size="large"
				as="a"
				href="/start-a-petition?source_location=topics-cta"
				data-qa="footer-sap-button"
				onClick={() => {
					void track('topic_sap_click_bottom');
				}}
			>
				<Translate value="corgi.topic_page.steps.button" />
			</Button>
		</div>
	);
};
